import { FormatterExtensions } from './formatterExtensions'
import { ArrayExtensions } from './arrayExtensions'

export const VueExtensions = {
  install(app) {
    /** @deprecated use $fmt.num(...) */
    const locale = 'en-US'

    /** @deprecated use $fmt.num(...) */
    const formatNumberGeneric = (
      value,
      decimals = 2,
      isCurrency = false,
      currency = 'USD'
    ) => {
      const options = {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }

      if (isCurrency) {
        options.style = 'currency'
        options.currency = currency
      }

      return new Intl.NumberFormat(locale, options).format(value)
    }

    /** @deprecated use $fmt.num(...) */
    app.config.globalProperties.$formatNumber = (value, decimals = 0) =>
      formatNumberGeneric(value, decimals)

    /** @deprecated use $fmt.curr(...) */
    app.config.globalProperties.$formatCurrency = (
      value,
      decimals = 2,
      currency = 'USD'
    ) => formatNumberGeneric(value, decimals, true, currency)

    /*
     * ...
     */
    app.config.globalProperties.$fmt = FormatterExtensions
    app.config.globalProperties.$arr = ArrayExtensions
  },
}
